import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-28 overflow-hidden" data-id="element-125">
      {/* Soft background elements */}
      <div className="absolute top-0 right-0 -z-10 w-full md:w-1/2 h-full bg-brand-pink/30 rounded-bl-full opacity-70 blur-3xl" data-id="element-126"></div>
      <div className="absolute bottom-0 left-0 -z-10 w-full md:w-1/3 h-1/2 bg-brand-sage/20 rounded-tr-full opacity-70 blur-3xl" data-id="element-127"></div>

      <div className="max-w-5xl mx-auto px-5 md:px-8" data-id="element-128">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-129">
          <div className="md:w-1/2 space-y-8 text-center md:text-left" data-id="element-130">
            <div className="space-y-4" data-id="element-131">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-dark leading-tight" data-id="element-132">
                A Calça Aperta no Fim do Dia?
              </h1>
              <h2 className="text-lg md:text-2xl font-medium text-brand-text/90 leading-relaxed" data-id="element-133">
                Recupere a Sensação de Cintura Leve e Reduza o Estufamento em
                Apenas 7 Dias
              </h2>
            </div>

            <p className="text-base md:text-lg text-brand-text/80 leading-relaxed" data-id="element-134">
              O protocolo simples para mulheres 40+ que querem desinchar,
              aliviar a sensação de peso e voltar a se sentir bem nas próprias
              roupas — sem dieta radical, sem academia pesada e sem passar fome.
            </p>

            <div className="pt-2 flex flex-col items-center md:items-start" data-id="element-135">
              <a href="#oferta" className="inline-block w-full md:w-auto bg-brand-dark hover:bg-brand-text text-white text-center font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-136">
                QUERO O PROTOCOLO
              </a>
              <p className="text-xs text-brand-text/60 mt-3 flex items-center justify-center md:justify-start" data-id="element-137">
                <span className="inline-block w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-138"></span>
                Compra segura via Hotmart. Acesso imediato no seu e-mail.
              </p>
            </div>
          </div>

          <div className="md:w-1/2 relative w-full max-w-md mx-auto" data-id="element-139">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-140">
              <img src="https://cdn.magicpatterns.com/uploads/2bHFqGKKPsD3k9ZTweTpvv/magnific_antes-imagen-realista-pre_BmzlvmtoQR.png" alt="Mulher 40+ feliz e leve" className="w-full h-auto object-cover" fetchPriority="high" data-id="element-141" />

              {/* Floating Ebook Mockup */}
              <div className="absolute -bottom-6 -left-6 w-32 md:w-40 drop-shadow-2xl transform -rotate-6" data-id="element-142">
                <img src="https://cdn.magicpatterns.com/uploads/pSwpDw56UKbHkib8Dj6KR7/magnific_premium-digital-ebook-moc_43x865h9Aa.png" alt="Protocolo Desincha40+ Ebook" className="w-full h-auto rounded-lg" data-id="element-143" />
              </div>
            </div>

            {/* Trust Badges */}
            <div className="absolute -right-4 top-8 flex flex-col gap-3" data-id="element-144">
              <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-md text-xs font-medium text-brand-dark flex items-center gap-2 border border-brand-sage/30" data-id="element-145">
                <CheckCircle2Icon className="w-4 h-4 text-brand-sage-dark" data-id="element-146" /> 21
                Dias
              </div>
              <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-md text-xs font-medium text-brand-dark flex items-center gap-2 border border-brand-sage/30" data-id="element-147">
                <CheckCircle2Icon className="w-4 h-4 text-brand-sage-dark" data-id="element-148" />{' '}
                Mulheres 40+
              </div>
              <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-md text-xs font-medium text-brand-dark flex items-center gap-2 border border-brand-sage/30" data-id="element-149">
                <CheckCircle2Icon className="w-4 h-4 text-brand-sage-dark" data-id="element-150" />{' '}
                Acesso Imediato
              </div>
              <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-md text-xs font-medium text-brand-dark flex items-center gap-2 border border-brand-sage/30" data-id="element-151">
                <CheckCircle2Icon className="w-4 h-4 text-brand-sage-dark" data-id="element-152" />{' '}
                Sem Dieta Radical
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}